/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Copy edge</h4>

<p>Select a set of edges and one vertex on each, and make all edges proportional copies of the first one selected.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('566457517')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>Ctrl-C</b>: Copy edge</li>
</ul>`;

export default function CopyEdgetooltip() {
    return h('div', { innerHTML: body });
}
